import { useState } from "react";
import { Button, Modal } from "cai-fusion";

const NewDataStoreSubfolderModal = ({ isHidden, onClose, clickOutsideToClose, onSubmit }) => {

    const [name, setName] = useState("");

	const handleKeyPress = (event) => {
		if (event.key === "Enter") {
			if (!event.shiftKey) {
				event.preventDefault();
				onSubmit(name);
				onClose();
				setName("");
			}
		}
	};

	return (
		<Modal
			isHidden={isHidden}
			id="rename-modal"
			clickOutsideToClose={clickOutsideToClose}
			title="Create Sub-Folder"
			onClose={(e) => {
				onClose();
				e.preventDefault();
			}}
			actions={
				<>
					<Button outline onClick={(e) => { e.preventDefault(); setName(""); onClose(); }} children="Cancel"/>
					<Button onClick={(e) => { e.preventDefault(); onSubmit(name); setName(""); onClose(); }} children="Create Folder"/>
				</>
			}
		>
			<div className="l-row">
				<div className="l-one-col">
					<form action="" className="o-form">
						<div className="m-form-group l-mt-sm">
							<label htmlFor="" className="a-label">Folder Name</label>
							<input type="text" value={name} onKeyDown={(e) => handleKeyPress(e)} onChange={(e) => { setName(e.target.value); e.preventDefault(); }} className="a-text-input"/>
						</div>
					</form>
				</div>
			</div>
		</Modal>
	);
};

export default NewDataStoreSubfolderModal;